export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result); // Includes the full Base64 string with the prefix
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
  });
}

export const getFileExtension = (url) => {
  if(!url) return '';
  return url.split('.').pop().split('?')[0];
}